import React, { forwardRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { useIsMobileDimension } from '@carnica/utils/hooks';
import { ChatWindow } from "../../../pages/chat-window/ui";
import { selectChatCofig, selectErrorScreenType, selectIsChatOpen, selectIsMenuOpen, setChatOpen, setErrorReason, setErrorScreenType } from "../../../entities/settings/model";
import { useChatOpen, useFixedBodyScroll, useInitialMessageQuery } from "../../lib/hooks";
import { ContextWrapper } from "../../model";
import { ImgPreview } from "../../../features/img-preview/ui";
import { FSMStages, useFSM } from "../../../shared/model";
import { ErrorReason, ErrorScreenType } from "../../../shared/config";
import { useOnlineStatus } from "../../../shared/lib";
var QueryWrapper = function QueryWrapper(_ref) {
  var children = _ref.children,
    enableQueriesParams = _ref.enableQueriesParams;
  useInitialMessageQuery(enableQueriesParams);
  return children;
};
var ChatRender = /*#__PURE__*/forwardRef(function (props, ref) {
  var isOpen = props.isOpen,
    callOfflineScreen = props.callOfflineScreen,
    errorScreenType = props.errorScreenType,
    _props$enableQueriesP = props.enableQueriesParams,
    enableQueriesParams = _props$enableQueriesP === void 0 ? true : _props$enableQueriesP,
    onChatOpen = props.onChatOpen,
    isChatOpen = props.isChatOpen;
  useChatOpen(isOpen);
  var isMobile = useIsMobileDimension();
  useFixedBodyScroll(isChatOpen, isMobile);
  var _useFSM = useFSM(),
    changeStage = _useFSM.changeStage;
  var isOnline = useOnlineStatus();
  useEffect(function () {
    // Для тех случаев когда мы закрыли чат вместе с экраном ошибки
    if (errorScreenType !== ErrorScreenType.UNKNOWN) {
      changeStage(FSMStages.ERROR);
    }
  }, [errorScreenType]);
  useEffect(function () {
    if (!isOnline) {
      callOfflineScreen();
      changeStage(FSMStages.ERROR);
    }
  }, [isOnline]);
  return /*#__PURE__*/React.createElement(ContextWrapper, null, /*#__PURE__*/React.createElement(QueryWrapper, {
    enableQueriesParams: enableQueriesParams
  }, /*#__PURE__*/React.createElement(ImgPreview, null), /*#__PURE__*/React.createElement(ChatWindow, {
    onChatOpen: onChatOpen,
    ref: ref
  })));
});
var mapStateToProps = function mapStateToProps(store) {
  var config = selectChatCofig(store);
  return {
    isMenuOpen: selectIsMenuOpen(store),
    isChatOpen: selectIsChatOpen(store),
    messengers: config.messengers,
    errorScreenType: selectErrorScreenType(store),
    zoneType: config.authZoneConfig.zoneType
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    closeChat: function closeChat() {
      return dispatch(setChatOpen(false));
    },
    callOfflineScreen: function callOfflineScreen() {
      dispatch(setErrorReason(ErrorReason.OFFLINE));
      dispatch(setErrorScreenType(ErrorScreenType.OFFLINE));
    }
  };
};
export var Chat = connect(mapStateToProps, mapDispatchToProps)(ChatRender);